<template>
  <el-drawer
    :visible="SistemAyarlariModal" size="50%">
    <div class="aimodal">
      <h2>Sistem Ayarları <a class="float-right" @click="$emit('SistemAyarlariModal', false)"><i
        class="el-icon-close"></i></a></h2>
      <el-form :model="Form" @submit.prevent.native="Submit()" :rules="FormHata" ref="Form" class="scrollkaydir"
               style="overflow-y: none">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Fatura Ünvanı" prop="Unvan">
              <el-input v-model="Form.Unvan"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Mail Adresi" prop="EMail">
              <el-input v-model="Form.EMail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Telefon" prop="Telefon">
              <el-input v-model="Form.Telefon"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Web Site" prop="Web">
              <el-input v-model="Form.Web"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="Fatura Adresi" prop="Adres">
              <el-input type="textarea" v-model="Form.Adres"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-tooltip class="item" effect="dark" content="Online işlemler giriş ekranında gözükecek olan logo"
                        placement="top">
              <small><i class="el-icon-info text-primary cursor-pointer"></i> Logo</small>
            </el-tooltip>
            <el-upload
              class="avatar-uploader"
              ref="upload"
              :show-file-list="false"
              :action="'https://cdn.mudu.pro/Drive/' + this.$store.getters.HesapId + '/Genel'"
              accept=" .jpg, .jpeg, .png"
              :on-success="DosyaIsle"
            >
              <img v-if="Form.Logo"
                   :src="'https://cdn.mudu.pro/Drive/upload/' + this.$store.getters.HesapId + '/Genel/'+Form.Logo"
                   class="avatar">
              <i class="el-icon-upload avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
          <div class="clearfix"></div>

          <el-col :span="8">
            <el-form-item label="Şehir" prop="Sehir">
              <el-select v-model="Form.Sehir" filterable>
                <el-option
                  v-for="item in Sehirler"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Vergi Dairesi" prop="vDairesi">
              <el-select v-model="Form.vDairesi" filterable>
                <el-option
                  v-for="item in VergiDaireleri"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Vergi No" prop="vNo">
              <el-input v-model="Form.vNo"></el-input>
            </el-form-item>
          </el-col>
          <div class="clearfix"></div>
          <hr>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Destek İzni" prop="Destek">
              <el-tooltip class="item" effect="dark"
                          content="Destek Personellerinin, destek için hesabınıza bağlanmasını sağlar" placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="Form.Destek"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item class="Tooltip" label="Telegram ID" prop="Telegram">
              <el-tooltip class="item" effect="dark"
                          content="Iss Crm sisteminin bütün bildirimlerini Telegram aracılığı ile almak için Telegram ID yazınız. Ardından 'IssBot' hesabını Telegramda aratarak ekleyiniz."
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input v-model="Form.Telegram"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div class="footer text-center">
        <hr>
        <el-button v-if="!lo" type="primary" size="medium" @click="Submit()" icon="el-icon-check">
          {{ $t('eGenel.0') }}
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>

export default {
  props: {
    SistemAyarlariModal: Boolean
  },
  data() {
    return {
      lo: false,

      Form: {
        Giris: false,
        GirisMail: false,
        Destek: false,
        TCKimlik: false,
        SmsSure: null,
        Termal: false,
        aSaat: null,
        kSaat: null,
        Logo: null,
        Unvan: null,
        EMail: null,
        Telefon: null,
        Web: null,
        vDaire: null,
        vNo: null,
        Adres: null,
        Sehir: null,
        Telegram: null,
        PrivateKey: null
      },
      FormHata: {
        Web: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Unvan: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        EMail: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Adres: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Sehir: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      Sehirler: [
        "ADANA",
        "ADIYAMAN",
        "AFYONKARAHİSAR",
        "AĞRI",
        "AMASYA",
        "ANKARA",
        "ANTALYA",
        "ARTVİN",
        "AYDIN",
        "BALIKESİR",
        "BİLECİKK",
        "BİNGÖL",
        "BİTLİS",
        "BOLU",
        "BURDUR",
        "BURSA",
        "ÇANAKKALE",
        "ÇANKIRI",
        "ÇORUM",
        "DENİZLİ",
        "DİYARBAKIR",
        "EDİRNE",
        "ELAZIĞ",
        "ERZİNCAN",
        "ERZURUM",
        "ESKİŞEHİR",
        "GAZİANTEP",
        "GİRESUN",
        "GÜMÜŞHANE",
        "HAKKARİ",
        "HATAY",
        "ISPARTA",
        "MERSİN",
        "İSTANBUL",
        "İZMİR",
        "KARS",
        "KASTAMONU",
        "KAYSERİ",
        "KIRKLARELİ",
        "KIRŞEHİR",
        "KOCAELİ",
        "KONYA",
        "KÜTAHYA",
        "MALATYA",
        "MANİSA",
        "KAHRAMANMARAŞ",
        "MARDİN",
        "MUĞLA",
        "MUŞ",
        "NEVŞEHİR",
        "NİĞDE",
        "ORDU",
        "RİZE",
        "SAKARYA",
        "SAMSUN",
        "SİİRT",
        "SİNOP",
        "SİVAS",
        "TEKİRDAĞ",
        "TOKAT",
        "TRABZON",
        "TUNCELİ",
        "ŞANLIURFA",
        "UŞAK",
        "VAN",
        "YOZGAT",
        "ZONGULDAK",
        "AKSARAY",
        "BAYBURT",
        "KARAMAN",
        "KIRIKKALE",
        "BATMAN",
        "ŞIRNAK",
        "BARTIN",
        "ARDAHAN",
        "IĞDIR",
        "YALOVA",
        "KARABüK",
        "KİLİS",
        "OSMANİYE",
        "DÜZCE"
      ],
      VergiDaireleri: [
        "5 OCAK VD",
        "ALADAĞ MAL MD.",
        "CEYHAN VD",
        "ÇUKUROVA VD",
        "FEKE MAL MD.",
        "İMAMOĞLU MAL MD.",
        "KARATAŞ VD",
        "KARAİSALI MAL MD.",
        "KOZAN VD",
        "POZANTI MAL MD.",
        "SAİMBEYLİ MAL MD.",
        "SEYHAN VD",
        "TUFANBEYLİ MAL MD.",
        "YUMURTALIK MAL MD.",
        "YÜREĞİR VD",
        "ZİYAPAŞA VD",
        "ADIYAMAN VD",
        "BESNİ MAL MD.",
        "ÇELİKHAN MAL MD.",
        "GERGER MAL MD.",
        "GÖLBAŞI MAL MD.",
        "KAHTA VD",
        "SAMSAT MAL MD.",
        "SİNCİK MAL MD.",
        "TUT MAL MD.",
        "BAYAT MAL MD.",
        "BAŞMAKÇI MAL MD.",
        "BOLVADİN VD",
        "ÇAY VD",
        "ÇOBANLAR MAL MD.",
        "DAZKIRI MAL MD.",
        "DİNAR VD",
        "EMİRDAĞ VD",
        "EVCİLER MAL MD.",
        "HOCALAR MAL MD.",
        "İHSANİYE MAL MD.",
        "İSCEHİSAR MAL MD.",
        "KIZILÖREN MAL MD.",
        "KOCATEPE VD",
        "SANDIKLI VD",
        "SULTANDAĞI MAL MD.",
        "SİNANPAŞA MAL MD.",
        "ŞUHUT MAL MD.",
        "TINAZTEPE VD",
        "AKSARAY VD",
        "AĞAÇÖREN MAL MD.",
        "ESKİL MAL MD.",
        "GÜLAĞAÇ MAL MD.",
        "GÜZELYURT MAL MD.",
        "ORTAKÖY MAL MD.",
        "SARIYAHŞİ MAL MD.",
        "AMASYA VD",
        "G. HACIKÖY VD",
        "GÖYNÜCEK MAL MD.",
        "GÜMÜŞHACIKÖY MAL MD.",
        "HAMAMÖZÜ MAL MD.",
        "MERZİFON VD",
        "SULUOVA VD",
        "TAŞOVA VD",
        "AKYURT MAL MD.",
        "AYAŞ MAL MD.",
        "BALA MAL MD.",
        "BAŞKENT VD",
        "BEYPAZARI VD",
        "CUMHURİYET VD",
        "ÇAMLIDERE MAL MD.",
        "ÇANKAYA VD",
        "ÇUBUK VD",
        "DIŞKAPI VD",
        "DOĞANBEY VD",
        "DİKİMEVİ VD",
        "ELMADAĞ VD",
        "ETİMESGUT VD",
        "EVREN MAL MD.",
        "GÖLBAŞI VD",
        "GÜDÜL MAL MD.",
        "HAYMANA VD",
        "HİTİT VD",
        "KALECİK MAL MD.",
        "KAVAKLIDERE VD",
        "KAZAN VD",
        "KEÇİÖREN VD",
        "KIZILBEY VD",
        "KIZILCAHAMAM MAL MD.",
        "M.KARAGÜZEL VD",
        "MALTEPE VD",
        "MİTHATPAŞA VD",
        "NALLIHAN MAL MD.",
        "OSTİM VD",
        "POLATLI VD",
        "SEĞMENLER VD",
        "SİNCAN VD",
        "ŞEREFLİKOÇHİSAR VD",
        "ULUS VD",
        "VERASET VE HARÇ VD",
        "Y.GALİP VD",
        "YENİMAHALLE VD",
        "YEĞENBEY VD",
        "YILDIRIMBEYAZIT VD",
        "AKSEKİ MAL MD.",
        "ALANYA VD",
        "ANTALYA KURUMLAR VD",
        "DEMRE MAL MD.",
        "DÜDEN VD",
        "ELMALI VD",
        "FİNİKE MAL MD.",
        "GAZİPAŞA MAL MD.",
        "GÜNDOĞMUŞ MAL MD.",
        "İBRADI MAL MD.",
        "KALEKAPI VD",
        "KAŞ MAL MD.",
        "KEMER VD",
        "KORKUTELİ MAL MD.",
        "KUMLUCA VD",
        "KUMLUCA MAL MD.",
        "MANAVGAT VD",
        "MURATPAŞA VD",
        "SERİK VD",
        "ÜÇKAPILAR VD",
        "ARDAHAN VD",
        "ÇILDIR MAL MD.",
        "DAMAL MAL MD.",
        "GÖLE MAL MD.",
        "HANAK MAL MD.",
        "POSOF MAL MD.",
        "ARDANUÇ MAL MD.",
        "ARHAVİ MAL MD.",
        "ARTVİN VD",
        "BORÇKA MAL MD.",
        "HOPA VD",
        "MURGUL MAL MD.",
        "ŞAVŞAT MAL MD.",
        "YUSUFELİ MAL MD.",
        "BOZDOĞAN MAL MD.",
        "BUHARKENT MAL MD.",
        "ÇİNE VD",
        "DİDİM VD",
        "EFELER VD",
        "GERMENCİK VD",
        "GÜZELHİSAR VD",
        "İNCİRLİOVA MAL MD.",
        "KARACASU MAL MD.",
        "KARPUZLU MAL MD.",
        "KOÇARLI MAL MD.",
        "KÖŞK MAL MD.",
        "KUYUCAK MAL MD.",
        "KUŞADASI VD",
        "NAZİLLİ VD",
        "SULTANHİSAR MAL MD.",
        "SÖKE VD",
        "YENİPAZAR MAL MD.",
        "AĞRI VD",
        "DOĞUBEYAZIT VD",
        "DİYADİN MAL MD.",
        "ELEŞKİRT MAL MD.",
        "HAMUR MAL MD.",
        "PATNOS MAL MD.",
        "TAŞLIÇAY MAL MD.",
        "TUTAK MAL MD.",
        "AYVALIK VD",
        "BALYA MAL MD.",
        "BANDIRMA VD",
        "BİGADİÇ VD",
        "BURHANİYE VD",
        "DURSUNBEY VD",
        "EDREMİT VD",
        "ERDEK VD",
        "GÖMEÇ MAL MD.",
        "GÖNEN VD",
        "HAVRAN MAL MD.",
        "İVRİNDİ MAL MD.",
        "KARESİ VD",
        "KEPSUT MAL MD.",
        "KURTDERELİ VD",
        "MANYAS MAL MD.",
        "MARMARA MAL MD.",
        "SAVAŞTEPE MAL MD.",
        "SINDIRGI VD",
        "SUSURLUK VD",
        "AMASRA MAL MD.",
        "BARTIN VD",
        "KURUCAŞİLE MAL MD.",
        "ULUS MAL MD.",
        "BATMAN VD",
        "BEŞİRİ MAL MD.",
        "GERCÜŞ MAL MD.",
        "HASANKEYF MAL MD.",
        "KOZLUK MAL MD.",
        "SASON MAL MD.",
        "AYDINTEPE MAL MD.",
        "BAYBURT VD",
        "DEMİRÖZÜ MAL MD.",
        "BOLU VD",
        "DÖRTDİVAN MAL MD.",
        "GEREDE VD",
        "GÖYNÜK MAL MD.",
        "KIBRISCIK MAL MD.",
        "MENGEN MAL MD.",
        "MUDURNU MAL MD.",
        "SEBEN MAL MD.",
        "YENİÇAĞA MAL MD.",
        "AĞLASUN MAL MD.",
        "ALTINYAYLA MAL MD.",
        "BUCAK VD",
        "BURDUR VD",
        "ÇAVDIR MAL MD.",
        "ÇELTİKÇİ MAL MD.",
        "GÖLHİSAR MAL MD.",
        "KARAMANLI MAL MD.",
        "KEMER MAL MD.",
        "TEFENNİ MAL MD.",
        "YEŞİLOVA MAL MD.",
        "BÜYÜKORHAN MAL MD.",
        "ÇEKİRGE VD",
        "ERTUĞRULGAZİ VD",
        "GEMLİK VD",
        "GÖKDERE VD",
        "HARMANCIK MAL MD.",
        "İNEGÖL VD",
        "İZNİK VD",
        "KARACABEY VD",
        "KELES MAL MD.",
        "MUDANYA VD",
        "MUSTAFAKEMALPAŞA VD",
        "NİLÜFER VD",
        "ORHANELİ MAL MD.",
        "ORHANGAZİ VD",
        "OSMANGAZİ VD",
        "SETBAŞI VD",
        "ULUDAĞ VD",
        "YENİŞEHİR VD",
        "YEŞİL VD",
        "YILDIRIM VD",
        "BİLECİK VD",
        "BOZÜYÜK VD",
        "GÖLPAZARI MAL MD.",
        "İNHİSAR MAL MD.",
        "OSMANELİ MAL MD.",
        "PAZARYERİ MAL MD.",
        "SÖĞÜT MAL MD.",
        "YENİPAZAR MAL MD.",
        "ADAKLI MAL MD.",
        "BİNGÖL VD",
        "GENÇ MAL MD.",
        "KARLIOVA MAL MD.",
        "KIĞI MAL MD.",
        "SOLHAN MAL MD.",
        "YAYLADERE MAL MD.",
        "YEDİSU MAL MD.",
        "ADİLCEVAZ MAL MD.",
        "AHLAT MAL MD.",
        "BİTLİS VD",
        "GÜROYMAK MAL MD.",
        "HİZAN MAL MD.",
        "MUTKİ MAL MD.",
        "TATVAN VD",
        "ACIPAYAM VD",
        "AKKÖY MAL MD.",
        "BABADAĞ MAL MD.",
        "BAKLAN MAL MD.",
        "BEKİLLİ MAL MD.",
        "BEYAĞAÇ MAL MD.",
        "BOZKURT MAL MD.",
        "BULDAN VD",
        "ÇAL VD",
        "ÇAMELİ MAL MD.",
        "ÇARDAK MAL MD.",
        "ÇINAR VD",
        "ÇİVRİL VD",
        "GÖKPINAR VD",
        "GÜNEY MAL MD.",
        "HONAZ MAL MD.",
        "KALE MAL MD.",
        "PAMUKKALE VD",
        "SARAYKÖY VD",
        "SARAYLAR VD",
        "SERİNHİSAR MAL MD.",
        "TAVAS VD",
        "AKÇAKOCA VD",
        "CUMAYERİ MAL MD.",
        "ÇİLİMLİ MAL MD.",
        "DÜZCE VD",
        "GÖLYAKA MAL MD.",
        "GÜMÜŞOVA MAL MD.",
        "KAYNAŞLI MAL MD.",
        "YIĞILCA MAL MD.",
        "BİSMİL MAL MD.",
        "C. SITKI TARANCI VD",
        "ÇERMİK MAL MD.",
        "ÇINAR MAL MD.",
        "ÇÜNGÜŞ MAL MD.",
        "DİCLE MAL MD.",
        "EĞİL MAL MD.",
        "ERGANİ MAL MD.",
        "GÖKALP VD",
        "HANİ MAL MD.",
        "HAZRO MAL MD.",
        "KOCAKÖY MAL MD.",
        "KULP MAL MD.",
        "LİCE MAL MD.",
        "SİLVAN MAL MD.",
        "SÜLEYMANNAZİF VD",
        "ARDA VD",
        "ENEZ MAL MD.",
        "HAVSA VD",
        "İPSALA VD",
        "KEŞAN VD",
        "KIRKPINAR VD",
        "LALAPAŞA MAL MD.",
        "MERİÇ MAL MD.",
        "SÜLOĞLU MAL MD.",
        "UZUNKÖPRÜ VD",
        "AĞIN MAL MD.",
        "ALACAKAYA MAL MD.",
        "ARICAK MAL MD.",
        "BASKİL MAL MD.",
        "HARPUT VD",
        "HAZAR VD",
        "KARAKOÇAN MAL MD.",
        "KEBAN MAL MD.",
        "KOVANCILAR MAL MD.",
        "MADEN MAL MD.",
        "PALU MAL MD.",
        "SİVRİCE MAL MD.",
        "AZİZİYE VD",
        "AŞKALE MAL MD.",
        "ÇAT MAL MD.",
        "HINIS MAL MD.",
        "HOROSAN MAL MD.",
        "ILICA MAL MD.",
        "İSPİR MAL MD.",
        "KARAÇOBAN MAL MD.",
        "KARAYAZI MAL MD.",
        "KAZIMKARABEKİR VD",
        "KÖPRÜKÖY MAL MD.",
        "NARMAN MAL MD.",
        "OLTU MAL MD.",
        "OLUR MAL MD.",
        "PASİNLER MAL MD.",
        "PAZARYOLU MAL MD.",
        "ŞENKAYA MAL MD.",
        "TEKMAN MAL MD.",
        "TORTUM MAL MD.",
        "UZUNDERE MAL MD.",
        "ÇAYIRLI MAL MD.",
        "FEVZİPAŞA VD",
        "İLİÇ MAL MD.",
        "KEMAH MAL MD.",
        "KEMALİYE MAL MD.",
        "OTLUKBELİ MAL MD.",
        "REFAHİYE MAL MD.",
        "TERCAN MAL MD.",
        "ÜZÜMLÜ MAL MD.",
        "2 EYLÜL VD",
        "ALPU MAL MD.",
        "BATTALGAZİ VD",
        "BEYLİKOVA MAL MD.",
        "ÇİFTELER VD",
        "GÜNYÜZÜ MAL MD.",
        "HAN MAL MD.",
        "İNÖNÜ MAL MD.",
        "MAHMUDİYE MAL MD.",
        "MİHALGAZİ MAL MD.",
        "MİHALIÇÇIK MAL MD.",
        "SARICAKAYA MAL MD.",
        "SEYİTGAZİ MAL MD.",
        "SİVRİHİSAR VD",
        "SİVRİHİSAR MAL MD.",
        "TAŞBAŞI VD",
        "YUNUSEMRE VD",
        "ARABAN MAL MD.",
        "GAZİKENT VD",
        "İSLAHİYE VD",
        "KARKAMIŞ MAL MD.",
        "KOZANLI VD",
        "NİZİP VD",
        "NURDAĞI MAL MD.",
        "OĞUZELİ MAL MD.",
        "SUBURCU VD",
        "ŞAHİNBEY VD",
        "ŞEHİTKAMİL VD",
        "YAVUZELİ MAL MD.",
        "GÜMÜŞHANE VD",
        "KELKİT MAL MD.",
        "KÖSE MAL MD.",
        "KÜRTÜN MAL MD.",
        "ŞİRAN MAL MD.",
        "TORUL MAL MD.",
        "ALUCRA MAL MD.",
        "BULANCAK VD",
        "ÇAMOLUK MAL MD.",
        "ÇANAKÇI MAL MD.",
        "DERELİ MAL MD.",
        "DOĞANKENT MAL MD.",
        "ESPİYE MAL MD.",
        "EYNESİL MAL MD.",
        "GİRESUN VD",
        "GÖRELE MAL MD.",
        "GÜCE MAL MD.",
        "KEŞAP MAL MD.",
        "PİRAZİZ MAL MD.",
        "ŞEBİNKARAHİSAR MAL MD.",
        "TİREBOLU MAL MD.",
        "YAĞLIDERE MAL MD.",
        "ÇUKURCA MAL MD.",
        "HAKKARİ VD",
        "ŞEMDİNLİ MAL MD.",
        "YÜKSEKOVA VD.",
        "23 TEMMUZ VD",
        "AKDENİZ VD",
        "ALTINÖZÜ MAL MD.",
        "ANTAKYA VD",
        "ASIM GÜNDÜZ VD",
        "BELEN MAL MD.",
        "DÖRTYOL VD",
        "ERZİN MAL MD.",
        "HASSA MAL MD.",
        "KIRIKHAN VD",
        "KUMLU MAL MD.",
        "REYHANLI VD",
        "SAHİL VD",
        "SAMANDAĞ VD",
        "ŞÜKRÜKANATLI VD",
        "YAYLADAĞ MAL MD.",
        "AKSU MAL MD.",
        "ATABEY MAL MD.",
        "DAVRAZ VD",
        "EĞİRDİR VD",
        "GELENDOST MAL MD.",
        "GÖNEN MAL MD.",
        "KAYMAKKAPI VD",
        "KEÇİBORLU MAL MD.",
        "SENİRKENT MAL MD.",
        "SÜTÇÜLER MAL MD.",
        "ŞARKİKARAAĞAÇ MAL MD.",
        "ULUBORLU MAL MD.",
        "YALVAÇ VD",
        "YENİŞARBADEMLİ M MAL MD.",
        "ARALIK MAL MD.",
        "IĞDIR VD",
        "KARAKOYUNLU MAL MD.",
        "TUZLUCA MAL MD.",
        "AFŞİN VD",
        "AKSU VD",
        "ANDIRIN MAL MD.",
        "ASLANBEY VD",
        "ÇAĞLIYANCERİT MAL MD.",
        "EKİNÖZÜ MAL MD.",
        "ELBİSTAN VD",
        "GÖKSUN MAL MD.",
        "NURHAK MAL MD.",
        "PAZARCIK VD",
        "TÜRKOĞLU MAL MD.",
        "EFLANİ MAL MD.",
        "ESKİPAZAR MAL MD.",
        "KARABÜK VD",
        "OVACIK MAL MD.",
        "SAFRANBOLU VD",
        "YENİCE MAL MD.",
        "AYRANCI MAL MD.",
        "BAŞYAYLA MAL MD.",
        "ERMENEK MAL MD.",
        "K.KARABEKİR MAL MD.",
        "KARAMAN VD",
        "SARIVELİLER MAL MD.",
        "AKYAKA MAL MD.",
        "ARPAÇAY MAL MD.",
        "DİGOR MAL MD.",
        "KAĞIZMAN MAL MD.",
        "KARS VD",
        "SARIKAMIŞ MAL MD.",
        "SELİM MAL MD.",
        "SUSUZ MAL MD.",
        "ABANA MAL MD.",
        "AĞLI MAL MD.",
        "ARAÇ MAL MD.",
        "AZDAVAY MAL MD.",
        "BOZKURT MAL MD.",
        "CİDE MAL MD.",
        "ÇATALZEYTİN MAL MD.",
        "DADAY MAL MD.",
        "DEVREKANİ MAL MD.",
        "DOĞANYURT MAL MD.",
        "HANÖNÜ MAL MD.",
        "İHSANGAZİ MAL MD.",
        "İNEBOLU MAL MD.",
        "KASTAMONU VD",
        "KÜRE MAL MD.",
        "PINARBAŞI MAL MD.",
        "SEYDİLER MAL MD.",
        "ŞENPAZAR MAL MD.",
        "TAŞKÖPRÜ VD",
        "TOSYA VD",
        "AKKIŞLA MAL MD.",
        "BÜNYAN VD",
        "DEVELİ VD",
        "ERCİYES VD",
        "FELAHİYE MAL MD.",
        "GEVHER NESİBE VD",
        "HACILAR MAL MD.",
        "İNCESU MAL MD.",
        "KALEÖNÜ VD",
        "MİMARSİNAN VD",
        "ÖZVATAN MAL MD.",
        "PINARBAŞI VD",
        "SARIOĞLAN MAL MD.",
        "SARIZ MAL MD.",
        "TOMARZA MAL MD.",
        "YAHYALI MAL MD.",
        "YEŞİLHİSAR MAL MD.",
        "BALIŞEYH MAL MD.",
        "ÇELEBİ MAL MD.",
        "DELİCE MAL MD.",
        "IRMAK VD",
        "KALETEPE VD",
        "KARAKEÇİLİ MAL MD.",
        "KESKİN MAL MD.",
        "SULAKYURT MAL MD.",
        "BABAESKİ VD",
        "DEMİRKÖY MAL MD.",
        "KIRKLARELİ VD",
        "KOFCAZ MAL MD.",
        "LÜLEBURGAZ VD",
        "PEHLİVANKÖY MAL MD.",
        "PINARHİSAR MAL MD.",
        "VİZE MAL MD.",
        "AKÇAKENT MAL MD.",
        "AKPINAR MAL MD.",
        "BOZTEPE MAL MD.",
        "ÇİÇEKDAĞI MAL MD.",
        "KAMAN VD",
        "KIRŞEHİR VD",
        "MUCUR MAL MD.",
        "ACISU VD",
        "ALEMDAR VD",
        "DERİNCE VD",
        "GÖLCÜK VD",
        "İLYASBEY VD",
        "KANDIRA MAL MD.",
        "KARAMÜRSEL VD",
        "KÖRFEZ VD",
        "TEPECİK VD",
        "ULUÇINAR VD",
        "AHIRLI MAL MD.",
        "AKÖREN MAL MD.",
        "AKŞEHİR VD",
        "ALAADDİN VD",
        "ALTINEKİN MAL MD.",
        "BEYŞEHİR VD",
        "BOZKIR MAL MD.",
        "CİHANBEYLİ VD",
        "ÇELTİK MAL MD.",
        "ÇUMRA VD",
        "DERBENT MAL MD.",
        "DEREBUCAK MAL MD.",
        "DOĞANHİSAR MAL MD.",
        "EMİRGAZİ MAL MD.",
        "EREĞLİ VD",
        "GÜNEYSINIR MAL MD.",
        "HADİM MAL MD.",
        "HALKAPINAR MAL MD.",
        "HÜYÜK MAL MD.",
        "ILGIN VD",
        "KADINHAN MAL MD.",
        "KARAPINAR MAL MD.",
        "KULU VD",
        "MERAM VD",
        "MEVLANA VD",
        "SARAYÖNÜ MAL MD.",
        "SELÇUK VD",
        "SEYDİŞEHİR VD",
        "TAŞKENT MAL MD.",
        "TUZLUKCU MAL MD.",
        "YALIHÜYÜK MAL MD.",
        "YUNAK MAL MD.",
        "30 AĞUSTOS VD",
        "ALTINTAŞ MAL MD.",
        "ASLANAPA MAL MD.",
        "ÇAVDARHİSAR MAL MD.",
        "ÇİNİLİ VD",
        "DOMANİÇ MAL MD.",
        "DUMLUPINAR MAL MD.",
        "EMET VD",
        "GEDİZ VD",
        "HİSARCIK MAL MD.",
        "PAZARLAR MAL MD.",
        "SİMAV VD",
        "ŞAPHANE MAL MD.",
        "TAVŞANLI VD",
        "KİLİS VD",
        "AKÇADAĞ MAL MD.",
        "ARAPKİR MAL MD.",
        "ARGUVAN MAL MD.",
        "BATTALGAZİ MAL MD.",
        "BEYDAĞI VD",
        "DARENDE MAL MD.",
        "DOĞANYOL MAL MD.",
        "DOĞANŞEHİR MAL MD.",
        "FIRAT VD",
        "HEKİMHAN MAL MD.",
        "KALE MAL MD.",
        "KULUNCAK MAL MD.",
        "PÖTÜRGE MAL MD.",
        "YAZIHAN MAL MD.",
        "YEŞİLYURT MAL MD.",
        "AHMETLİ MAL MD.",
        "AKHİSAR VD",
        "ALAŞEHİR VD",
        "ALAYBEY VD",
        "DEMİRCİ VD",
        "GÖLMARMARA MAL MD.",
        "GÖRDES VD",
        "KIRKAĞAÇ VD",
        "KÖPRÜBAŞI MAL MD.",
        "KULA VD",
        "MESİR VD",
        "SALİHLİ ADİL ORA VD",
        "SARIGÖL VD",
        "SARUHANLI VD",
        "SELENDİ MAL MD.",
        "SOMA VD",
        "TURGUTLU VD",
        "DARGEÇİT MAL MD.",
        "DERİK MAL MD.",
        "KIZILTEPE VD",
        "MARDİN VD",
        "MAZIDAĞI MAL MD.",
        "MİDYAT MAL MD.",
        "NUSAYBİN VD",
        "ÖMERLİ MAL MD.",
        "SAVUR MAL MD.",
        "YEŞİLLİ MAL MD.",
        "ANAMUR VD",
        "AYDINCIK MAL MD.",
        "BOZYAZI MAL MD.",
        "ÇAMLIYAYLA MAL MD.",
        "ERDEMLİ VD",
        "GÜLNAR MAL MD.",
        "İSTİKLAL VD",
        "KIZILMURAT VD",
        "LİMAN VD",
        "MUT MAL MD.",
        "SİLİFKE VD",
        "ŞEHİTKERİM VD",
        "TOROS VD",
        "URAY VD",
        "BODRUM VD",
        "DALAMAN MAL MD.",
        "DATÇA MAL MD.",
        "FETHİYE VD",
        "KAVAKLIDERE MAL MD.",
        "KÖYCEĞİZ VD",
        "MARMARİS VD",
        "MİLAS VD",
        "MUĞLA VD",
        "ORTACA MAL MD.",
        "ULA MAL MD.",
        "YATAĞAN VD",
        "BULANIK MAL MD.",
        "HASKÖY MAL MD.",
        "KORKUT MAL MD.",
        "MALAZGİRT MAL MD.",
        "MUŞ VD",
        "VARTO MAL MD.",
        "ACIGÖL MAL MD.",
        "AVANOS MAL MD.",
        "DERİNKUYU MAL MD.",
        "GÜLŞEHİR MAL MD.",
        "HACIBEKTAŞ MAL MD.",
        "KOZAKLI MAL MD.",
        "NEVŞEHİR VD",
        "ÜRGÜP MAL MD.",
        "ALTUNHİSAR MAL MD.",
        "BOR VD",
        "ÇAMARDI MAL MD.",
        "ÇİFTLİK MAL MD.",
        "NİĞDE VD",
        "ULUKIŞLA MAL MD.",
        "AKKUŞ MAL MD.",
        "AYBASTI MAL MD.",
        "BOZTEPE VD",
        "ÇAMAŞ MAL MD.",
        "ÇATALPINAR MAL MD.",
        "ÇAYBAŞI MAL MD.",
        "FATSA VD",
        "GÖLKÖY MAL MD.",
        "GÜLYALI MAL MD.",
        "GÜRGENTEPE MAL MD.",
        "İKİZCE MAL MD.",
        "KABADÜZ MAL MD.",
        "KABATAŞ MAL MD.",
        "KORGAN MAL MD.",
        "KÖPRÜBAŞI VD",
        "KUMRU MAL MD.",
        "MESUDİYE MAL MD.",
        "PERŞEMBE MAL MD.",
        "ULUBEY MAL MD.",
        "ÜNYE VD",
        "BAHÇE MAL MD.",
        "DÜZİÇİ MAL MD.",
        "HASANBEYLİ MAL MD.",
        "KADİRLİ VD",
        "OSMANİYE VD",
        "SUMBAS MAL MD.",
        "TOPRAKKALE MAL MD.",
        "ARDEŞEN VD",
        "ÇAMLIHEMŞİN MAL MD.",
        "ÇAYELİ VD",
        "DEREPAZARI MAL MD.",
        "FINDIKLI MAL MD.",
        "GÜNEYSU MAL MD.",
        "HEMŞİN MAL MD.",
        "İKİZDERE MAL MD.",
        "İYİDERE MAL MD.",
        "KALKANDERE MAL MD.",
        "KAÇKAR VD",
        "PAZAR VD",
        "YEŞİLÇAY VD",
        "AKYAZI VD",
        "ALİ FUAT CEBESOY VD",
        "GEYVE VD",
        "GÜMRÜKÖNÜ VD",
        "HENDEK VD",
        "KARAPÜRÇEK MAL MD.",
        "KARASU VD",
        "KAYNARCA MAL MD.",
        "KOCAALİ MAL MD.",
        "PAMUKOVA MAL MD.",
        "SAPANCA MAL MD.",
        "TARAKLI MAL MD.",
        "19 MAYIS VD",
        "19 MAYIS MAL MD.",
        "ALAÇAM MAL MD.",
        "ASARCIK MAL MD.",
        "AYVACIK MAL MD.",
        "BAFRA VD",
        "ÇARŞAMBA VD",
        "GAZİLER VD",
        "HAVZA VD",
        "KAVAK MAL MD.",
        "LADİK MAL MD.",
        "SALIPAZARI MAL MD.",
        "TEKKEKÖY MAL MD.",
        "TERME VD",
        "VEZİRKÖPRÜ MAL MD.",
        "YAKAKENT MAL MD.",
        "ZAFER VD",
        "AYANCIK MAL MD.",
        "BOYABAT VD",
        "DURAĞAN MAL MD.",
        "DİKMEN MAL MD.",
        "ERFELEK MAL MD.",
        "GERZE MAL MD.",
        "SARAYDÜZÜ MAL MD.",
        "SİNOP VD",
        "TÜRKELİ MAL MD.",
        "AKINCILAR MAL MD.",
        "ALTINYAYLA MAL MD.",
        "DİVRİĞİ MAL MD.",
        "DOĞANŞAR MAL MD.",
        "GEMEREK MAL MD.",
        "GÖLOVA MAL MD.",
        "GÜRÜN MAL MD.",
        "HAFİK MAL MD.",
        "İMRANLI MAL MD.",
        "KALE VD",
        "KANGAL MAL MD.",
        "KOYULHİSAR MAL MD.",
        "SİTE VD",
        "SUŞEHRİ MAL MD.",
        "ŞARKIŞLA VD",
        "ULAŞ MAL MD.",
        "YILDIZELİ MAL MD.",
        "ZARA MAL MD.",
        "BAYKAN MAL MD.",
        "ERUH MAL MD.",
        "KURTALAN MAL MD.",
        "PERVARİ MAL MD.",
        "SİİRT VD",
        "ŞİRVAN MAL MD.",
        "ÇERKEZKÖY VD",
        "ÇORLU VD",
        "HAYRABOLU VD",
        "MALKARA VD",
        "MARM. EREĞLİSİ MAL MD.",
        "MURATLI VD",
        "NAMIK KEMAL VD",
        "SARAY MAL MD.",
        "SÜLEYMANPAŞA VD",
        "ŞARKÖY MAL MD.",
        "ALMUS MAL MD.",
        "ARTOVA MAL MD.",
        "BAŞÇİFTLİK MAL MD.",
        "ERBAA VD",
        "NİKSAR VD",
        "PAZAR MAL MD.",
        "REŞADİYE MAL MD.",
        "SULUSARAY MAL MD.",
        "TOKAT VD",
        "TURHAL VD",
        "YEŞİLYURT MAL MD.",
        "ZİLE VD",
        "AKÇAABAT VD",
        "ARAKLI MAL MD.",
        "ARSİN MAL MD.",
        "BEŞİKDÜZÜ MAL MD.",
        "ÇARŞIBAŞI MAL MD.",
        "ÇAYKARA MAL MD.",
        "DERNEKPAZARI MAL MD.",
        "DÜZKÖY MAL MD.",
        "HAYRAT MAL MD.",
        "HIZIRBEY VD",
        "KARADENİZ VD",
        "KÖPRÜBAŞI MAL MD.",
        "MAÇKA MAL MD.",
        "OF VD",
        "SÜRMENE MAL MD.",
        "ŞALPAZARI MAL MD.",
        "TONYA MAL MD.",
        "VAKFIKEBİR VD",
        "YOMRA MAL MD.",
        "ÇEMİŞGEZEK MAL MD.",
        "HOZAT MAL MD.",
        "MAZGİRT MAL MD.",
        "NAZİMİYE MAL MD.",
        "OVACIK MAL MD.",
        "PERTEK MAL MD.",
        "PÜLÜMÜR MAL MD.",
        "TUNCELİ VD",
        "BANAZ VD",
        "EŞME VD",
        "KARAHALLI MAL MD.",
        "SİVASLI MAL MD.",
        "ULUBEY MAL MD.",
        "UŞAK VD",
        "BAHÇESARAY MAL MD.",
        "BAŞKALE MAL MD.",
        "ÇALDIRAN MAL MD.",
        "ÇATAK MAL MD.",
        "EDREMİT MAL MD.",
        "ERCİŞ VD",
        "GEVAŞ MAL MD.",
        "GÜRPINAR MAL MD.",
        "MURADİYE MAL MD.",
        "ÖZALP MAL MD.",
        "SARAY MAL MD.",
        "VAN VD",
        "ALTINOVA MAL MD.",
        "ARMUTLU MAL MD.",
        "ÇINARCIK MAL MD.",
        "YALOVA VD",
        "AKDAĞMADENİ MAL MD.",
        "AYDINCIK MAL MD.",
        "BOĞAZLIYAN VD",
        "ÇANDIR MAL MD.",
        "ÇAYIRALAN MAL MD.",
        "ÇEKEREK MAL MD.",
        "KADIŞEHRİ MAL MD.",
        "SARAYKENT MAL MD.",
        "SARIKAYA MAL MD.",
        "SORGUN VD",
        "ŞEFAATLİ MAL MD.",
        "YENİFAKILI MAL MD.",
        "YERKÖY VD",
        "YOZGAT VD",
        "ALAPLI MAL MD.",
        "ÇAYCUMA VD",
        "DEVREK VD",
        "GÖKÇEBEY MAL MD.",
        "KARADENİZ EREĞLİ VD",
        "KARAELMAS VD",
        "UZUNMEHMET VD",
        "AYVACIK MAL MD.",
        "BAYRAMİÇ MAL MD.",
        "BİGA VD",
        "BOZCAADA MAL MD.",
        "ÇAN VD",
        "ÇANAKKALE VD",
        "ECEABAT MAL MD.",
        "EZİNE MAL MD.",
        "GELİBOLU VD",
        "GÖKÇEADA MAL MD.",
        "LAPSEKİ MAL MD.",
        "YENİCE MAL MD.",
        "ATKARACALAR MAL MD.",
        "BAYRAMÖREN MAL MD.",
        "ÇANKIRI VD",
        "ÇERKEŞ MAL MD.",
        "ELDİVAN MAL MD.",
        "ILGAZ MAL MD.",
        "KIZILIRMAK MAL MD.",
        "KORGUN MAL MD.",
        "KURŞUNLU MAL MD.",
        "ORTA MAL MD.",
        "ŞABANÖZÜ MAL MD.",
        "YAPRAKLI MAL MD.",
        "ALACA MAL MD.",
        "BAYAT MAL MD.",
        "BOĞAZKALE MAL MD.",
        "ÇORUM VD",
        "DODURGA MAL MD.",
        "İSKİLİP MAL MD.",
        "KARGI MAL MD.",
        "LAÇİN MAL MD.",
        "MECİTÖZÜ MAL MD.",
        "OĞUZLAR MAL MD.",
        "ORTAKÖY MAL MD.",
        "OSMANCIK MAL MD.",
        "SUNGURLU VD",
        "UĞURLUDAĞ MAL MD.",
        "ADALAR VD",
        "ANADOLU KURUMLAR VD",
        "ATIŞALANI VD",
        "AVCILAR VD",
        "BAKIRKÖY VD",
        "BAYRAMPAŞA VD",
        "BEŞİKTAŞ VD",
        "BEYAZIT VD",
        "BEYKOZ VD",
        "BEYLİKDÜZÜ VD",
        "BEYOĞLU VD",
        "BOĞAZİÇİ KUR. VD",
        "BÜYÜK MÜK. VD. B VD",
        "BÜYÜKÇEKMECE VD",
        "ÇAPA VD",
        "ÇATALCA VD",
        "DAVUTPAŞA VD",
        "DIŞ TİC. VD",
        "ERENKÖY VD",
        "ESENLER VD",
        "FATİH VD",
        "GALATA VD",
        "GAZİOSMANPAŞA VD",
        "GÖZTEPE VD",
        "GÜNEŞLİ VD",
        "GÜNGÖREN VD",
        "HALKALI VD",
        "HİSAR VD",
        "HOCAPAŞA VD",
        "İKİTELLİ VD",
        "KADIKÖY VD",
        "KAĞITHANE VD",
        "KARTAL VD",
        "KASIMPAŞA VD",
        "KOCAMUSTAFAPAŞA VD",
        "KOCASİNAN VD",
        "KOZYATAĞI VD",
        "KÜÇÜKÇEKMECE VD",
        "KÜÇÜKKÖY VD",
        "KÜÇÜKYALI VD",
        "LALELİ VD",
        "MARMARA KUR. VD",
        "MASLAK VD",
        "MECİDİYEKÖY VD",
        "MERCAN VD",
        "MERTER VD",
        "MEVLANAKAPI VD",
        "NAKİL VASITA. VD",
        "NURUOSMANİYE VD",
        "PENDİK VD",
        "RAMİ VD",
        "RIHTIM VD",
        "SARIGAZİ VD",
        "SARIYER VD",
        "SİLİVRİ VD",
        "SULTANAHMET VD",
        "SULTANBEYLİ VD",
        "SÜLEYMANİYE VD",
        "ŞİLE VD",
        "ŞİŞLİ VD",
        "TUNA VD",
        "TUZLA VD",
        "ULAŞTIRMA VD",
        "ÜMRANİYE VD",
        "ÜSKÜDAR VD",
        "YAKACIK VD",
        "YEDİTEPE VD",
        "YENİ BOSNA VD",
        "ZEYTİNBURNU VD",
        "ZİNCİRLİKUYU VD",
        "9 EYLÜL VD",
        "ALİAĞA VD",
        "BALÇOVA VD",
        "BASMANE VD",
        "BAYINDIR VD",
        "BELKAHVE VD",
        "BERGAMA VD",
        "BEYDAĞ MAL MD.",
        "BORNOVA VD",
        "ÇAKABEY VD",
        "ÇEŞME VD",
        "ÇİĞLİ VD",
        "DİKİLİ MAL MD.",
        "EGE VD",
        "FOÇA MAL MD.",
        "GAZİEMİR VD",
        "HASAN TAHSİN VD",
        "KADİFEKALE VD",
        "KARABURUN MAL MD.",
        "KARŞIYAKA VD",
        "KEMALPAŞA VD",
        "KEMERALTI VD",
        "KINIK VD",
        "KİRAZ VD",
        "KONAK VD",
        "KORDON VD",
        "MENDERES VD",
        "MENEMEN VD",
        "ÖDEMİŞ VD",
        "SEFERİHİSAR MAL MD.",
        "SELÇUK VD",
        "ŞİRİNYER VD",
        "TAŞITLAR VD",
        "TİRE VD",
        "TORBALI VD",
        "URLA VD",
        "YAMANLAR VD",
        "AKÇAKALE MAL MD.",
        "BİRECİK VD",
        "BOZOVA MAL MD.",
        "CEYLANPINAR MAL MD.",
        "HALFETİ MAL MD.",
        "HARRAN MAL MD.",
        "HİLVAN MAL MD.",
        "SİVEREK VD",
        "SURUÇ MAL MD.",
        "ŞEHİTLİK VD",
        "TOPÇUMEYDANI VD",
        "VİRANŞEHİR VD",
        "BEYTÜŞŞEBAB MAL MD.",
        "CİZRE VD",
        "CİZRE MAL MD.",
        "GÜÇLÜKONAK MAL MD.",
        "İDİL MAL MD.",
        "SİLOPİ VD",
        "SİLOPİ MAL MD.",
        "ŞIRNAK VD",
        "ULUDERE MAL MD.",
      ],
    }
  },
  methods: {
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'spesiyal/sistem'})
        .then(response => {
          if (response.Durum == "OK") {
            this.Form = response.Data;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
    },
    DosyaIsle(response, file, DosyaListesi) {
      if (response == 'done') {
        this.Logo = file.name
        this.$store.dispatch("Post", {Logo: this.Logo, path: 'spesiyal/logo'})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle()
            } else {
              this.$message.error(response.Mesaj);
            }
          })
      }
    },
    Submit() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          // EKLE
          this.$store.dispatch("Post", {...this.Form, path: 'spesiyal/sistem'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.$message.success(response.Mesaj);
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      });
    }
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Genel/SistemAyarlari.vue